"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.assertResponseSuccess = assertResponseSuccess;
exports.getSwicusWebAppUrl = exports.generateRequestID = void 0;

var generateRequestID = function generateRequestID() {
  var length = 6;
  var allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var text = '';

  for (var i = 0; i < length; i++) {
    text += allowedChars.charAt(Math.floor(Math.random() * allowedChars.length));
  }

  return text;
};

exports.generateRequestID = generateRequestID;

var getSwicusWebAppUrl = function getSwicusWebAppUrl(environment) {
  return environment === 'production' ? 'https://my.solarwinds.cloud' : 'https://st-my.solarwinds.cloud';
};

exports.getSwicusWebAppUrl = getSwicusWebAppUrl;

function assertResponseSuccess(response) {
  if (!response.ok) {
    throw new Error("Expected status was OK (200-299) but got ".concat(response.status));
  }
}